import React from "react";
import Text from "components/common/Text";
import CTable from "components/common/Table";
import { withRouter } from "react-router";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import Switch from "../common/Switch";
import { Formik } from "formik";
import * as yup from "yup";
import TextField from "components/common/TextField";
import Box from "components/common/Box";
import Button from "components/common/Button";
import Stack from "components/common/Stack";
import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const AmenitiesList = ({
  data,
  handleClickUpdate,
  submitAmenities,
  handleStatusAddAmenities,
  isloadingAmenitiesTable,
}) => {
  const classes = useStyles();


  const initialValues = {
    amenitiesname: "",
  };

  const validateAmenitiesForm = yup.object().shape({
    amenitiesname: yup
      .string()
      .required("Amenity is required")
      .trim("Amenity cannot contain extra spaces")
      .strict(true)
      .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field "),
  });

  const columns = [
    {
      field: "name",
      headerName: "List of Amenities",
    },

    {
      field: "price",
      headerName: "Action",
      valueGetter: (v, d) => {
        return (
          <>
            {
              <>
                <EditOutlinedIcon
                  className={classes.aminityicon}
                  onClick={() => {
                    handleClickUpdate(d?.id, d?.name);
                  }}
                  sx={{
                    cursor: "pointer",
                    color: "#004AAD",
                    marginLeft: "36%",
                  }}
                />

                {
                  <Switch
                    checked={d.status === 1 ? true : false}
                    onClick={() => handleStatusAddAmenities(d.id, d.status)}
                    sx={{ marginBottom: "20px" }}
                  />
                }
              </>
            }
          </>
        );
      },
    },
  ];

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => {
          submitAmenities(values);
          values.amenitiesname = "";
        }}
        validationSchema={validateAmenitiesForm}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          isValid,
          values,
          touched,
          errors,
        }) => (
          <>
            <Text
              variant="h5"
              color="#707070"
              sx={{
                fontSize: "24px",
                marginBottom: "25px",
                marginTop: "15px",
              }}
            >
              Add Amenity
            </Text>
            <Stack>
              <Text sx={{ color: "#666666", fontSize: "14px" }}>
                Enter Amenity
              </Text>
              <Box className={classes.aminity} sx={{ width: "27rem" }}>
                <TextField
                  className={classes.aminitytext}
                  size="small"
                  sx={{ width: "19rem" }}
                  onChange={handleChange("amenitiesname")}
                  onBlur={handleBlur("amenitiesname")}
                  inputProps={{ style: { textTransform: "capitalize" } }}
                  value={values.amenitiesname}
                  error={
                    !touched.amenitiesname && Boolean(errors.amenitiesname)
                  }
                />

                {errors.amenitiesname && (
                  <Typography sx={{ color: "red" }}>
                    {errors.amenitiesname}
                  </Typography>
                )}
              </Box>
            </Stack>
            <Stack mt={1.5}>
              <Button
                variant="outlined"
                sx={{
                  width: "94.17px",
                  height: "51.41px",
                  fontSize: "16px",
                  borderColor: "#004AAD",
                  color: "#0071C5",
                }}
                size="small"
                onClick={() => {
                  handleSubmit();
                }}
                disabled={!isValid}
              >
                + Add
              </Button>
              <br></br>
              <CTable
                columns={columns}
                data={data}
                isLoading={isloadingAmenitiesTable}
                pagination={true}
                localPagination={true}
                page={0}
                rowsPerPage={5}
              ></CTable>
            </Stack>
          </>
        )}
      </Formik>
    </>
  );
};
const useStyles = makeStyles((theme) => ({
  aminitytext: {
    "@media (max-width:768px)": {
      width: "100%",
    },
  },
  aminity: {
    "@media (max-width:768px)": {
      width: "100%",
    },
  },
  aminityicon: {
    "@media (max-width:768px)": {
      marginLeft: "-11px",
    },
  },
}));
export default withRouter(AmenitiesList);
